import React from 'react';
import { UncontrolledAccordion } from 'reactstrap';

import VersionerDocumentComparisonSidebarAiSummaryContainer from './ai_summary_container';
import VersionerDocumentComparisonSidebarChatContainer from './chat_container';
import VersionerDocumentComparisonSidebarCollaboratorContainer from './collaborator_container';

const VersionerDocumentComparisonSidebarPanel = (props) => {
  const {
    thread,
    comparison,
    currentItem,
    previousItem,
    configuration,
    helpers: {
      isPortalContext: isPortalContextHelper,
      itemName: itemNameHelper,
    },
    callbacks: {
      callbackOnSetThread: callbackOnSetThread
    }
  } = props;

  return (
    <UncontrolledAccordion defaultOpen="1">
      <VersionerDocumentComparisonSidebarAiSummaryContainer
        comparison={comparison}
        currentItem={currentItem}
        previousItem={previousItem}
        configuration={configuration}
        helpers={{
          isPortalContext: isPortalContextHelper,
        }}
        callbacks={{
          callbackOnSetThread: callbackOnSetThread
        }}
      />
      <VersionerDocumentComparisonSidebarChatContainer
        thread={thread}
        item={ currentItem }
        data={ props?.data }
        configuration={configuration}
        helpers={{
          isPortalContext: isPortalContextHelper,
          itemName: itemNameHelper
        }}
      />
      <VersionerDocumentComparisonSidebarCollaboratorContainer
        collaborators={thread?.collaborators}
        helpers={{
          isPortalContext: isPortalContextHelper
        }}
        routes={{
          editThreadPath: Routes.edit_versioner_document_thread_path({ id: thread?.hashid })
        }}
      />
    </UncontrolledAccordion>
  );
};

export default VersionerDocumentComparisonSidebarPanel;
